import { render } from "./ResetPasswordFailure.vue?vue&type=template&id=355fa608&scoped=true"
import script from "./ResetPasswordFailure.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFailure.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=355fa608&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355fa608"]])

export default __exports__